const CitizenAlertMessages = {
    'missing.cpf': 'O campo "CPF" é obrigatório.',
    'missing.cnpj': 'O campo "CNPJ" é obrigatório.',
    'missing.name': 'O campo "Nome" é obrigatório.',
    'missing.sex': 'O campo "Sexo" é obrigatório.',
    'missing.protectionProgram': 'O campo "Programa" é obrigatório.',
    'missing.dtBirth': 'O campo "Nascimento" é obrigatório.',
    'missing.protectionType': 'O campo "Tipo de medida" é obrigatório.',
    'cpf.already.registered': 'Este "CPF" já está sendo utilizado.',
    'cnpj.already.registered': 'Este "CNPJ" já está sendo utilizado.',
    'identificationNumber.already.exists': 'Este "Número de identificação" já está sendo utilizado.',
    'missing.vehicle.plate': 'O campo "Placa" dos veículos protegido é obrigatório.',
    'missing.contact.phone': 'O campo "Telefone" é obrigatório.',
    'missing.addressType': 'O campo "Tipo de local" é obrigatório.',
    'missing.address': 'O campo "Logradouro" é obrigatório.',
    'missing.city': 'O campo "Município" é obrigatório.',
    'missing.number': 'O campo "Número" é obrigatório.',
    'missing.neighborhood': 'O campo "Bairro" é obrigatório.',
    'missing.latitude': 'O campo "Latitude" é obrigatório.',
    'missing.longitude': 'O campo "Longitude" é obrigatório.',
    'missing.location': 'Os campos "Latitude" e "Longitude" são obrigatórias.',
    'invalid.latitude': 'Latitude inválida. Informe um valor entre -90 e 90.',
    'invalid.longitude': 'Longitude inválida. Informe um valor entre -180 e 180.',
    'missing.scheduleWindow': 'Informe o "Horário inicial" e "Horário final" para endereços de visita/ronda.',
    'invalid.scheduleWindow': 'O "Horário final" deve ser posterior ao "Horário inicial".',
    'missing.aggressorPicture': 'Selecione uma foto.',
    'missing.inactivationReason': 'O campo "Motivo da inativação" é obrigatório.',
    'missing.inactivationDescription': 'O campo "Descrição da inativação" é obrigatório.',
    'missing.aggressor': 'É necessário adicionar ao menos um agressor.',
    'missing.aggressor.name': 'O campo "Nome" (Agressor) é obrigatório.',
    'missing.aggressor.protectionType': 'O campo "Tipo de medida" (Agressor) é obrigatório.',
    'missing.availabilityEndTime': 'O campo "Horário inicial" é obrigatório.',
    'missing.availabilityStartTime': 'O campo "Horário final" é obrigatório.',

    // Import Table
    'citizenInfo.dtBirth.invalid': 'Formato inválido.',
    'protectionType.invalid': '"Tipo de medida" inválido.',
    'lifeRisk.invalid': '"Grau de risco" inválido',
    'protectiveMeasure.educationId.invalid': '"Escolaridade" inválida.',
    'protectiveMeasure.raceEthnicityId.invalid': '"Raça ou etnia" inválida.',
    'protectiveMeasure.religionId.invalid': '"Religião" inválida.',
    'aggressor.educationId.invalid': '"Escolaridade" inválida.',
    'aggressor.missing.name': 'O campo "Nome" é obrigatório.',
    'aggressor.raceEthnicityId.invalid': '"Raça ou etnia" inválida.',
    'aggressor.religionId.invalid': '"Religião" inválida.',
    'aggressor.familyConnectionId.invalid': '"Vínculo com protegido" inválido.',
    'aggressor.dtBirth.invalid': 'Formato inválido.',
    'aggressor.dtExpiration.invalid': 'Formato inválido.',
    'aggressor.dtExpedition.invalid': 'Formato inválido.',
    'invalid.program.id': 'Programa de proteção inválido.',
}

const targets = ["citizenInfo", "aggressor", "protectedPlaces"];

targets.forEach(target => {
    CitizenAlertMessages[target + ".missing.addressType"] = 'O campo "Tipo de local" é obrigatório.';
    CitizenAlertMessages[target + ".addressType.invalid"] = '"Tipo de local" inválido.';
    CitizenAlertMessages[target + ".missing.address"] = 'O campo "Logradouro" é obrigatório.';
    CitizenAlertMessages[target + ".missing.number"] = 'O campo "Número" é obrigatório.';
    CitizenAlertMessages[target + ".missing.neighborhood"] = 'O campo "Bairro" é obrigatório.';
    CitizenAlertMessages[target + ".missing.city"] = 'O campo "Município" é obrigatório.';
    CitizenAlertMessages[target + ".missing.district"] = 'O campo "Estado (UF)" é obrigatório.';
    CitizenAlertMessages[target + ".missing.latitude"] = 'O campo "Latitude" é obrigatório.';
    CitizenAlertMessages[target + ".missing.longitude"] = 'O campo "Longitude" é obrigatório.';
    CitizenAlertMessages[target + ".latitude.invalid"] = 'Latitude inválida.';
    CitizenAlertMessages[target + ".longitude.invalid"] = 'Longitude inválida.';
});

export default CitizenAlertMessages;